// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as GemInnerStoredProceduresGem } from '../../../../../ui-v3/src/assets/icons/gem/monotone/gem-inner-stored-procedures.svg?react';
import { createIcons } from '../../Icon';
const GemInnerStoredProceduresIcon = /* @__PURE__ */ createIcons('GemInnerStoredProcedures', {
    gem: GemInnerStoredProceduresGem
});
GemInnerStoredProceduresIcon.supportedTypes = [
    'gem'
];
GemInnerStoredProceduresIcon.category = 'monotone';
export default GemInnerStoredProceduresIcon;
